// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-date-time-picker-input {\n  background: transparent !important;\n}\n.vpd-wrapper.vpd-is-popover {\n  z-index: 9999 !important;\n}\n.friday-highlighted {\n  color: #fd6363;\n}\n.friday-highlighted .vpd-day-effect {\n  background-color: #fd6363 !important;\n}\n.friday-highlighted.vpd-addon-list-item {\n  color: #fd6363 !important;\n}\n.friday-highlighted.vpd-addon-list-item.vpd-selected {\n  background-color: #f1d4de;\n}", ""]);
// Exports
module.exports = exports;
